var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dialogue',{attrs:{"is-visible":_vm.isVisible,"is-wide":""}},[_c('fragment',[_c('p',{staticClass:"is-bold text-center"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("map-dialogue-content"),_c('ButtonsContainer',{staticClass:"buttons-container"},[_c('Button',{attrs:{"text":"Close","on-click":() => _vm.$emit('close')}})],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }